"use client";

import { ClientOnly } from './ClientOnly';

interface ClientContentProps {
  children: React.ReactNode;
  className?: string;
}

export const ClientContent = ({ 
  children, 
  className 
}: ClientContentProps) => {
  return (
    <ClientOnly>
      <div className={className}>
        {children}
      </div>
    </ClientOnly>
  );
};